import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import type { Dispatch, SetStateAction } from "react";
import { EditExplorationForm } from "../../forms/myExplorations/EditExplorationForm";

const EditExplorationSheet = ({
  open,
  onOpenChange,
  setExplorations,
  data,
  exploration,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setExplorations: Dispatch<
    SetStateAction<{
      explorations: any[];
      classes: any[];
      rotations: any[];
      sessions: any[];
      teachers: any[];
    }>
  >;
  data: { rotations: any[]; sessions: any[]; teachers: any[] };
  exploration: any;
}) => {
  const onSuccess = () => {
    onOpenChange(false);
  };


  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Edit {exploration.name}</SheetTitle>
          <SheetDescription>
            Edit {exploration.name}'s details, acces, and session.
          </SheetDescription>
        </SheetHeader>
        <EditExplorationForm
          onSuccess={onSuccess}
          setExplorations={setExplorations}
          data={data}
          exploration={exploration}
        />
      </SheetContent>
    </Sheet>
  );
};

export { EditExplorationSheet };
